module.exports = __webpack_public_path__ + "static/media/deshaw.99264934.png";